
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import * as AppConstant from '../common/AppConstant'
import Errors from '../common/Errors';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTrackingExpiration = this.handleTrackingExpiration.bind(this);
        this.state = {
            password: "",
            confirm: "",
            isTrackingExpired:false,
            apiStatus: {
                isError: true,
                message: '',
                messages:''
            }

        };
    }

    componentDidMount(){
        this.handleTrackingExpiration()
    }

    handleTrackingExpiration(){
        fetch(this.props.api + '/login/handleTrackingExpiration/'+this.props.params.tracking, {
            method: "POST",
            mode: 'cors',
            headers: {'content-type': 'application/json'}
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                const {apiStatus}  = this.state;
                let isTrackingExpired = false
                if (json && json.isError === false) {
                    apiStatus.isError = false;
                    apiStatus.message = json.message
                    apiStatus.messages = json.messages
                    isTrackingExpired = false
                } else {
                    const {apiStatus}  = this.state;
                    apiStatus.isError = true;
                    apiStatus.message = json.message
                    apiStatus.messages = json.messages
                    isTrackingExpired = true
                }
                this.setState({apiStatus:apiStatus, isTrackingExpired:isTrackingExpired})
            })
            .catch(error => console.error(error));
    }

    handleFormSubmit() {
        let body = {
            confirm: this.state.confirm,
            password: this.state.password
        };
        const {apiStatus}  = this.state;
        apiStatus.isError = false;
        apiStatus.message = ""
        this.setState({apiStatus:apiStatus, isTrackingExpired:false})
        if(AppConstant.validateValue( this.props.params.tracking,"S") === false){
            const {apiStatus}  = this.state;
            apiStatus.isError = true;
            apiStatus.message = "Invalid url or expired url"
            this.setState({apiStatus:apiStatus})
            return
        }

        if(AppConstant.validateValue( this.state.confirm,"S") === false
            && AppConstant.validateValue( this.state.password,"S") === false){
            const {apiStatus}  = this.state;
            apiStatus.isError = true;
            apiStatus.message = "Confirm and Password should be valid and cannot be blank"
            this.setState({apiStatus:apiStatus})
            return
        }

        if(this.state.confirm !== this.state.password ){
            const {apiStatus}  = this.state;
            apiStatus.isError = true;
            apiStatus.message = "Confirm and Password should be match"
            this.setState({apiStatus:apiStatus})
            return
        }

        fetch(this.props.api + '/login/resetPassword/'+this.props.params.tracking, {
            body: JSON.stringify(body),
            method: "POST",
            mode: 'cors',
            headers: {'content-type': 'application/json'}
        })
        .then(response => response.json())
        .then(json => {
                console.log(json);
                const {apiStatus}  = this.state;
                if (json && json.isError === false) {
                    apiStatus.isError = false;
                    apiStatus.message = json.message
                    apiStatus.messages = json.messages
                } else {
                    const {apiStatus}  = this.state;
                    apiStatus.isError = true;
                    apiStatus.message = json.message
                    apiStatus.messages = json.messages
                }
                this.setState({apiStatus:apiStatus})
        })
        .catch(error => console.error(error));
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    render() {
        let _this = this;
        let displayForm = 'block'
        if(_this.state.isTrackingExpired === true){
            displayForm = 'none'
        }
        return (
            <div className="passwordBox animated fadeInDown">
                <div className="row">

                    <div className="col-md-12">
                        <div className="ibox-content">

                            <h2 className="font-bold">{_this.props.msg('resetPassword.password')}</h2>
                                             {/*<span style={{'color':this.state.apiStatus.isError===true?'red':'green'}}>
                                                            {this.state.apiStatus.message ? this.state.apiStatus.message : ''}
                                             </span>*/}
                            <Errors errorObject={this.state.apiStatus}/>
                            <br/>
                            <p style={{display:displayForm}}>
                                {_this.props.msg('resetPassword.note')}
                            </p>

                            <div className="row" style={{display:displayForm}}>

                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input type="password" className="form-control" placeholder="Enter password"
                                               name='password' id='password'
                                               value={this.state.password}
                                               onChange={this.handleChange}/>
                                    </div>

                                    <div className="form-group">
                                        <input type="password" className="form-control" placeholder="Enter confirm"
                                        name='confirm'  id='confirm'
                                        value={this.state.confirm}
                                        onChange={this.handleChange}/>
                                    </div>
                                    <a onClick={this.handleFormSubmit} className="btn btn-primary block full-width m-b">{_this.props.msg('resetPassword.changePassword')}</a>
                                    <Link className="btn btn-primary block full-width m-b" to="/login">{_this.props.msg('forgotPassword.goToLogin')}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
        )
    }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/security/ResetPassword.js